<template>
  <crud-modal
    :title="$t('modals.company.deleteTitle')"
    action="delete"
    :on-submit="submit"
    :on-close="() => $emit('close')"
  >
    <div class="mb-6">
      {{ $t('modals.company.deleteConfirmPrefix') }}
      <span class="font-semibold">"{{ companyName }}"</span> {{ $t('modals.company.deleteConfirmSuffix') }}
    </div>

    <div class="p-4 mb-6 border-2 border-red-600 bg-red-100 text-red-900">
      <p class="mb-2 font-bold uppercase">
        {{ $t('modals.company.deleteDangerTitle') }}
      </p>
      <p>
        {{ $t('modals.company.deleteDangerText') }}
      </p>
    </div>

    <div class="flex mb-6">
      <div class="w-1/3">
        {{ $t('modals.company.deleteWarning') }}
      </div>
      <ul class="w-2/3 pl-6 list-disc">
        <li>{{ $t('modals.company.deleteListFiles') }}</li>
        <li>{{ $t('modals.company.deleteListLandingpages') }}</li>
        <li>{{ $t('modals.company.deleteListLeads') }}</li>
        <li>{{ $t('modals.company.deleteListUsers') }}</li>
      </ul>
    </div>

    <div class="mb-6">
      <p class="mb-2">
        {{ $t('modals.company.deleteSlugInstruction') }}
        <code class="px-2 py-1 font-mono font-semibold text-red-900 bg-red-100">{{ companySlug }}</code>
      </p>
      <ValidationProvider
        v-slot="{ errors }"
        :rules="{ required: true, matchesValue: { expected: companySlug } }"
      >
        <label class="block normal-case">
          {{ $t('modals.company.deleteSlugLabel') }}:
          <input
            v-model.trim="confirmationSlug"
            type="text"
            autocomplete="off"
            class="w-full font-mono"
            :class="{ 'border-red-500': errors.length }"
          >
        </label>
        <p
          v-if="errors.length"
          class="text-xs text-red-500"
          v-text="errors[0]"
        />
      </ValidationProvider>
    </div>

    <ValidationProvider
      v-slot="{ errors }"
      rules="checked"
    >
      <label class="flex items-start mb-2 normal-case">
        <input
          v-model="hasConfirmedDeletion"
          type="checkbox"
          class="flex-shrink-0 w-4 h-4 mt-1 mr-3 border-2 border-gray-600 form-checkbox"
          :class="{ 'border-red-500': errors.length }"
        >
        <span>{{ $t('modals.company.deleteIrreversibleConfirm') }}</span>
      </label>
      <p
        v-if="errors.length"
        class="text-xs text-red-500"
        v-text="errors[0]"
      />
    </ValidationProvider>
  </crud-modal>
</template>

<script>
import CrudModal from '@/components/modals/crud-modal'
import DELETE_COMPANY from '@/graphql/DeleteCompany.gql'

export default {
  components: { CrudModal },
  props: {
    companyId: {
      type: String,
      required: true
    },
    companyName: {
      type: String,
      required: true
    },
    companySlug: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      confirmationSlug: '',
      hasConfirmedDeletion: false
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: DELETE_COMPANY,
        variables: {
          id: this.companyId
        }
      })
    }
  }
}
</script>
